export default "__VITE_ASSET__WLhPoxH3__"